<script lang="ts">
    import { buildAlternateLinks, getHref } from '@shared/routing';
    import { SupportedLanguage } from '@shared/types';

    import { page } from '$app/stores';

    export let locale: SupportedLanguage;
</script>

<!-- Error pages shouldn't have hreflang -->
{#if !$page.error && $page.data}
    <!-- Alternate links are generated on-demand. So we need to call the `buildAlternateLinks` -->
    {#each buildAlternateLinks($page.url) as [hreflang, href]}
        <link rel="alternate" {hreflang} {href} />
    {/each}
    <!-- After they're generated you can reference them normally -->
    <link rel="alternate" hreflang="x-default" href={getHref($page.url, SupportedLanguage.English)} />
    <link rel="canonical" href={getHref($page.url, locale)} />
{/if}
